import { useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex";
import DocumentTemplateForm from "../DocumentTemplateForm/DocumentTemplateForm";

const FORM_ID = "document-template-form";

function New({ account, permission }) {
  const navigate = useNavigate();

  return (
    <div className="newDocumentTemplatesPage">
      <AdminFormPage
        title="Add Document Template"
        formId={permission !== "view" ? FORM_ID : undefined}
        onCancel={() => navigate(`/admin/document_templates`, { state: null })}
      >
        <DocumentTemplateForm
          formId={FORM_ID}
          documentTemplateProp={undefined}
          account={account}
          permission={permission}
          refetch={() => null}
        />
      </AdminFormPage>
    </div>
  );
}

export default New;
